<template>
  <div class="timesince">{{ timeSince }} <span v-if="type !== 'chat'"> ago</span></div>
</template>

<script>
import { timeSince, timeSinceMin } from "@/functions/utility.js";

export default {
  name: "newTimesince",
  props: {
    timestamp: [Object, String],
    type: String,
  },
  data: () => ({
    interval: 0
  }),
  computed: {
    timeSince() {
      let timesince = this.type === 'chat' ?
        timeSinceMin(this.timestamp) :
        typeof this.timestamp === 'string' ? 
          timeSince({seconds: new Date(this.timestamp).valueOf()/1000}) : timeSince(this.timestamp);

      if (timesince.includes("-")) {
        timesince = "0 secs";
      }
      return timesince;
    },
  },
  mounted() {
    this.interval = setInterval(() => {
      this._computedWatchers.timeSince.run();
      this.$forceUpdate();
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style scoped lang="scss">
@import "~@/scss/components/sidebar/timesince.scss";
</style>
